// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1ckXM","footer":"ChangeClinic_footer__d5w_o"};